import {useCallback, useState} from 'react';

export default function useProductColorData({
  getProductImageSrcData,
  initialSelectedColorId
}) {
  const [colorData, setColorData] = useState(() => ({
    colorId: initialSelectedColorId,
    image: getProductImageSrcData(initialSelectedColorId)
  }));

  const onChangeColor = useCallback(
    (colorId, noMoreLaydowns = false, colorIdOverride = false) => {
      setColorData({
        colorId,
        image: getProductImageSrcData(colorId, noMoreLaydowns, colorIdOverride)
      });
    },
    [getProductImageSrcData]
  );

  return {colorData, onChangeColor};
}
